import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { ObsService } from '../../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss'],
})
export class DropDownComponent implements OnInit {
  data: any = [];
  response: any = [];
  response2: any = [];
  isLoading = true;
  dropdown: any = [];
  mode = 'table';
  deleted;

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService,
    private obs: ObsService
  ) {}

  Form = new FormGroup({
    Id: new FormControl(0),
    Name: new FormControl(''),
  });

  Form2 = new FormGroup({
    Id: new FormControl(0),
    DropdownId: new FormControl(''),
    OptionName: new FormControl(''),
    OptionValue: new FormControl(''),
    OptionCode: new FormControl(''),
  });

  getDrop() {
    this.obs.getDropdown().subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
      }
    );
  }

  ngOnInit(): void {
    this.obs.getDropdown().subscribe(
      (resSuccess) => {
        this.data = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
      }
    );
  }

  getValues(data) {
    this.mode = 'value';
    this.obs.getDropdownValues(data.Id).subscribe(
      (resSuccess) => {
        this.mode = 'value';
        this.dropdown = resSuccess;
        console.log(this.dropdown);
      },
      (resErr) => {}
    );
  }
  delete(data) {
    let Id = data.Id;
    let IsDropdown = true;
    let IsDropdownValue = true;
    this.obs.deleteDropdown(Id, IsDropdown, IsDropdownValue).subscribe(
      (resSuccess: []) => {
        this.deleted = resSuccess;
        this.isLoading = false;
        console.log(this.deleted);

        if (!this.response.HasError) {
          this.data = this.data.filter((dattum) => dattum.Id !== data.Id);
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }
  back() {
    this.mode = 'table';
  }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    const { Id, Name } = this.Form.value;
    this.obs.createDropdown(Id, Name).subscribe(
      (resSuccess: []) => {
        this.response = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (!this.response.HasError) {
          this.Form.reset();
          this.getDrop();
          this.isLoading = false;
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  Submit(e) {
    e.preventDefault();
    this.isLoading = true;
    const { Id, DropdownId, OptionName, OptionValue, OptionCode } =
      this.Form2.value;
    const IsActive = true;
    this.obs
      .createDropdownValue(
        Id,
        DropdownId,
        OptionName,
        OptionValue,
        OptionCode,
        IsActive
      )
      .subscribe(
        (resSuccess: []) => {
          this.response2 = resSuccess;
          this.isLoading = false;

          if (!this.response2.HasError) {
            this.Form2.reset();
            this.isLoading = false;
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.isLoading = false;
            this._snackBar.open('Error: Please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(resSuccess);
          }
        },
        (resErr) => {
          this.isLoading = false;
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }
}
